<template>
  <div>

    <v-fade-transition mode="out-in">
      <v-alert 
        class="my-3"
        v-if="!loading && rfqs.length == 0"
        type="info">
        There are no RFQs.
      </v-alert>

      <table
        v-if="loading || rfqs.length > 0" 
        class="table is-fullwidth is-hoverable is-clickable has-smaller-font">
        <thead>
          <tr>
            <th v-for="(header, i) in headers" :key="i">
              {{ header }}
            </th>
          </tr>
          <tr v-if="loading">
            <th :colspan="headers.length" class="py-0 px-0 is-naked">
              <v-progress class="is-fullwidth" v-model="loading"/>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr @click="viewRfq(rfq)" v-for="rfq in rfqs" :key="rfq.id">
            <td>
              {{ rfq.project.project_name }}
            </td>
            <td>
              <div class="is-size-7">
                {{ rfq.rfq_name}}
              </div>
              <div class="help has-text-grey text--nowrap">
                Version {{ rfq.version }}
              </div>
            </td>
            <td>
              <div class="is-size-7">
                {{ rfq.created_user.display_name }}
              </div>
              <div class="help has-text-grey text--nowrap">
                {{ formatDate(parseDate(rfq.created_on)) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-fade-transition>

    <v-pagination 
      class="mt-3"
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>
  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VProgress from '@/components/base/VProgress'
import VAlert from '@/components/base/VAlert'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import { mapState, mapActions, mapMutations } from 'vuex'

import { parseJSON, format } from 'date-fns'

export default {
  props: {
    filters: {
      type: Object
    }
  },
  components: { VPagination, VProgress, VAlert, VFadeTransition },
  data() {
    return {
      headers: ['Project', 'Name & Version', 'Created By/ On'],
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => format(date, "yyyy-MM-dd HH:mm")
    }
  },
  computed: {
    ...mapState("rfqs", ["rfqs", "loading", "pagination"])
  },
  watch: {
    'pagination.page'() {
      let params = { ...this.filters, ...this.pagination };
      params.simplified = true;
      this.getRfqs(params);
    },
    filters: {
      handler(filters) {
        let params = { ...filters };
        params.simplified = true;
        this.getRfqs(params);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("rfqs", ["getRfqs"]),
    ...mapMutations("rfqs", ["changePage"]),
    initialize() {
      let params = { ...this.filters };
      params.simplified = true;
      this.getRfqs(this.filters);
    },
    viewRfq(rfq) {
      this.$router.push({ 
        name: 'RfqViewer',
        params: {
          productBrand: this.filters.product_brand,
          rfqId: rfq.id
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>